const React = require("react");
const { useSyncee } = require("../context/SynceeContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, LinkButton, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;
const DropshippingPlatforms = () => {
  const { api, t } = useSyncee();
  const resource = useResource(async () => ({ ...(await api.getPlatform()), ...(await api.getConnection()) }), [api]);
  const platform = resource.data?.platform;
  const connection = resource.data?.connection;
  return h(React.Fragment, null,
    h(PageHeader, { title: t("h_syncee_platform_title", "Syncee platform"), description: t("h_syncee_platform_desc", "Explore verified suppliers and synchronize their dropshipping products with Elakay.") }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !platform, reload: resource.reload, t }, platform ?
      h("article", { className: "synds-card" }, h("div", { className: "synds-card-body" },
        h("div", { className: "synds-row synds-between" }, h("h3", null, platform.name), h(StatusBadge, { status: connection?.status || "not_connected", t })),
        h("p", { className: "synds-muted" }, t("h_syncee_platform_explain", "Elakay imports and updates Syncee catalog products. Each supplier remains responsible for fulfillment and returns.")),
        h("div", { className: "synds-row" }, h(LinkButton, { to: "/dropshipping/syncee/connect" }, connection?.status === "active" ? t("h_syncee_manage", "Manage connection") : t("h_syncee_connect", "Connect Syncee")), h(LinkButton, { to: "/dropshipping/syncee/products", variant: "secondary" }, t("h_syncee_products", "Products")))
      )) : null)
  );
};
module.exports = { DropshippingPlatforms };
